<a
  class="dropdown-item"
  download
  href="{{ menuItem?.url }}"
  target="{{ menuItem?.target }}"
  id="help-{{ menuItem?.text }}"
>
  <i class="{{ menuItem?.cssClass }}"></i>
  {{ menuItem?.text }}
</a>
